import { observer } from 'mobx-react';
import * as React from 'react';
import { ExperienceResource } from '../../../../../../Types';
import LearningCollectionEditStore from '../../../../../Edit/Store';
import { ModifiableExperiencesContext } from '../../../../../Types';
import OnDemand from './OnDemand';
import ScheduledDates from './ScheduledDates';

interface Props {
  context: ModifiableExperiencesContext;
  experienceResource: ExperienceResource;
  store: LearningCollectionEditStore;
}

const StartDates: React.FC<Props> = ({ context, experienceResource, store }) => {
  switch (experienceResource.payload.offeringType) {
    case 'aep':
    case 'coaching':
    case 'program-sequence':
      return <OnDemand />;
    case 'epc':
      return (
        <ScheduledDates context={context} experienceResource={experienceResource} store={store} />
      );
    case 'group-coaching':
      return <></>;
  }
};

export default observer(StartDates);
